import React from 'react';

const combineContext = (providers: Array<(props: any) => JSX.Element>) => ({ children }: {children: any}) => providers.reverse().reduce((tree: any, Provider: any) => <Provider>{tree}</Provider>, children);

export default combineContext;
